export default function MerchantsExportController($scope, $window, merchantService) {
  var vm = this;

  vm.merchantId = null;
  vm.merchantBrowserUrl = null;
  vm.lastMerchantId = null;
  vm.url = '';
  vm.isLoading = false;
  vm.validLink = false;

  vm.generateLink = function() {
    if (!vm.merchantId) {
      return;
    }

    vm.validLink = false;
    merchantService
      .exportCustomers(vm.merchantId)
      .then(function(res) {
        var blob = new Blob([res.data], { type: 'text/csv' });
        vm.url = ($window.URL || $window.webkitURL).createObjectURL(blob);
        vm.validLink = true;
      })
      .finally(function() {
        vm.isLoading = false;
      });
  };

  vm.getMerchantById = function() {
    if (vm.isLoading || vm.lastMerchantId === vm.merchantId) {
      return;
    }

    vm.isLoading = true;

    merchantService
      .getMerchantById(vm.merchantId)
      .then(function(res) {
        vm.merchantBrowserUrl = res.data.browserUrl;
        vm.lastMerchantId = vm.merchantId;
        vm.generateLink();
      })
      .finally(function() {
        vm.isLoading = false;
      });
  };

  $scope.$watch('vm.merchantId', function() {
    vm.validLink = false;
  });
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchants.export.controller.js